import { CssVarManagerInter } from '.'
/**
 * 获得组件与cssVar变量的映射.
 * 将变量管理对象转换成一个mapper映射,以便子项能够快速匹配
 * @param cssVarManager 变量管理对象
 */
export const getCompCssVarMapper = <T extends CssVarManagerInter>(
  cssVarManager: T,
  mapper: Record<string, CssVarManagerInter> = {}
) => {
  for (const key in cssVarManager) {
    const val = cssVarManager[key]
    if (typeof val === 'object') {
      mapper[key] = val
      getCompCssVarMapper(val, mapper)
    }
  }
  return mapper
}
